const UNIDADES_STI = [
    {
        sigla: "ISTAI",
        nomeLongo: "IST SENAI em Tecnologia em Automação Industrial",
        nomeCurto: "Instituto SENAI de Tecnologia em Automação (ISTAI)"
    },
    {
        sigla: "ISTTC",
        nomeLongo: "IST SENAI em Tecnologia Têxtil e Confecção",
        nomeCurto: "Instituto SENAI de Tecnologia Têxtil e Confecções (ISTTC)"
    },
    {
        sigla: "ISTEO",
        nomeLongo: "IST SENAI em Tecnologia em Eficiência Operacional",
        nomeCurto: "IST Eficiência Operacional (ISTEO)"
    },
];

// devolve a sigla original se não encontrar, igual ao switch original (sem default)
function parseNomeLongoSTI(sigla) {
    let unidade = UNIDADES_STI.find((u) => u.sigla === sigla);
    return unidade ? unidade.nomeLongo : sigla;
}

// devolve undefined se não encontrar, igual ao switch original (sem default)
function parseNomeCurtoSTI(sigla) {
    let unidade = UNIDADES_STI.find((u) => u.sigla === sigla);
    return unidade && unidade.nomeCurto;
}

export default {
    UNIDADES_STI,
    parseNomeLongoSTI,
    parseNomeCurtoSTI
};
